import { gql } from '@apollo/client';

export const GET_PROFILE_ATTRIBUTES = gql`
  query User($userId: ID!){
    user(userId: $userId){
      id
      profile {
        id
        email
        firstName
        lastName
        gender
        birthdate
        country
        smartphone
        computer
        tablet
        state
        browsers
        otherDevices
        webExpertise
        paypalAccount
        raceEthnicHeritage
        annualHouseholdIncome
        workStatus
        languages
        educationLevel
        jobCategories{
          id
          name
        }
        currentPosition{
          title
          seniority
          company{
            size
            industry
          }
        }
      }
    }
  }
`;

export const LAST_EDITION = gql`
  query Profile {
    profileEditedLastThreeMonths
  }
`;
